import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add' || event.context !== 'product') return;

  event.promise
    .then((result) => {
      if (result?.detail?.didError) return;

      window.location.href = Theme.routes.checkout_url;
    })
    .catch(() => {});
});
